<template>
    <v-app :dark="darkMode">
        <v-navigation-drawer
            disable-resize-watcher
            v-if="userLogged"
            :mini-variant="false"
            :clipped="false"
            v-model="drawer"
            temporary
            right
            app
        >
            <v-list expand nav>
                <template v-for="item in items">
                    <template v-if="item.children">
                        <v-list-group v-model="item.model" :key="item.text" class="mb-1">
                            <v-icon v-if="item.icon" slot="prependIcon" :color="item.color">{{
                                item.icon
                            }}</v-icon>
                            <template v-slot:activator>
                                <v-list-item-content>
                                    <v-list-item-title
                                        :class="[
                                            { subheading: item.largeq },
                                            `${item.color}--text`,
                                        ]"
                                        v-text="item.text"
                                    ></v-list-item-title>
                                </v-list-item-content>
                            </template>
                            <template v-for="(child, i) in item.children">
                                <v-list-item
                                    :key="i"
                                    :to="child.to"
                                    @click="callAction(child.action)"
                                    :color="child.color"
                                >
                                    <v-list-item-action v-if="child.icon">
                                        <v-icon :color="child.color" :large="child.large">{{
                                            child.icon
                                        }}</v-icon>
                                    </v-list-item-action>
                                    <v-list-item-content>
                                        <v-list-item-title>{{ child.text }}</v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <v-btn
                                            :color="child.additional.color"
                                            outlined
                                            icon
                                            :to="{ name: child.additional.to }"
                                            @click="callAction(child.additional.action)"
                                            v-if="child.additional"
                                        >
                                            <v-icon>{{ child.additional.icon }}</v-icon>
                                        </v-btn>
                                    </v-list-item-action>
                                </v-list-item>
                            </template>
                        </v-list-group>
                        <v-divider v-if="item.divider" :key="`${item.text}div`"></v-divider>
                    </template>
                    <template v-else>
                        <v-list-item
                            :to="item.to"
                            :color="item.color"
                            :key="item.text"
                            @click="item.action ? item.action : () => {}"
                        >
                            <v-list-item-action>
                                <v-icon :large="item.large" :color="item.color">{{
                                    item.icon
                                }}</v-icon>
                            </v-list-item-action>
                            <v-list-item-content>
                                <v-list-item-title :class="[{ subheading: item.large }]">{{
                                    item.text
                                }}</v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-action>
                                <v-btn
                                    :color="item.additional.color"
                                    outlined
                                    icon
                                    :to="{ name: item.additional.to }"
                                    @click="callAction(item.additional.action)"
                                    v-if="item.additional"
                                >
                                    <v-icon :color="item.additional.color">{{
                                        item.additional.icon
                                    }}</v-icon>
                                </v-btn>
                            </v-list-item-action>
                        </v-list-item>
                    </template>
                </template>
            </v-list>
        </v-navigation-drawer>
        <v-app-bar app>
            <a :href="userLogged ? '/login' : '/dashboard/'">
                <img src="@/assets/logo.png" style="height: 60px;    margin-bottom: -4px;" />
            </a>
            <v-toolbar-title class="headline text-uppercase web-site-title black-text">
                <router-link :to="{ name: 'home' }">
                    <span v-t="'site_title'"></span>
                    <span class="font-weight-light" v-t="'site_title2'"></span>
                </router-link>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items class="hidden-sm-and-down" v-if="userLogged" :dark="darkMode">
                <v-btn
                    text
                    :to="{
                        name: 'traps',
                    }"
                >
                    <v-icon left>inbox</v-icon>
                    {{ $t("menu.traps") }}
                </v-btn>
                <v-btn
                    text
                    :to="{
                        name: 'categories',
                    }"
                >
                    <v-icon left>category</v-icon>
                    {{ $t("menu.categories") }}
                </v-btn>
                <v-btn
                    text
                    :to="{
                        name: 'plans',
                    }"
                >
                    <v-icon left>place</v-icon>
                    {{ $t("menu.plans") }}
                </v-btn>
                <v-btn
                    text
                    :to="{
                        name: 'stats',
                    }"
                >
                    <v-icon left>assessment</v-icon>
                    {{ $t("menu.stats") }}
                </v-btn>
                <v-menu offset-y>
                    <template v-slot:activator="{ on }">
                        <v-btn text v-on="on" color="green">
                            <v-icon left>account_circle</v-icon>
                            {{ $t("menu.my_account") }}
                            <v-icon right>keyboard_arrow_down</v-icon>
                        </v-btn>
                    </template>
                    <v-list>
                        <v-list-item :to="{ name: 'account' }">
                            <v-list-item-action>
                                <v-icon>settings</v-icon>
                            </v-list-item-action>
                            <v-list-item-title>{{ $t("menu.account_settings") }}</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="logout">
                            <v-list-item-action>
                                <v-icon color="error">logout</v-icon>
                            </v-list-item-action>
                            <v-list-item-title class="error--text">{{
                                $t("menu.logout")
                            }}</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </v-toolbar-items>
            <v-spacer class="hidden-md-and-up"></v-spacer>
            <v-app-bar-nav-icon
                class="hidden-md-and-up"
                v-if="userLogged"
                @click.stop="drawer = !drawer"
            ></v-app-bar-nav-icon>
        </v-app-bar>
        <v-content>
            <v-snackbar
                :value="offline"
                :timeout="0"
                color="error"
                top
                left
                class="main-error absolute-alert"
            >
                <strong>{{ $t("error.offline") }}</strong>
            </v-snackbar>
            <v-snackbar
                :value="!serverStatus && !offline"
                :timeout="2000"
                color="error"
                top
                left
                class="main-error"
            >
                <strong>{{ $t("error.server_error") }}</strong>
            </v-snackbar>
            <Notify />
            <keep-alive :max="10">
                <router-view v-if="$route.meta.keepAlive" :key="routeKey"></router-view>
            </keep-alive>
            <router-view v-if="!$route.meta.keepAlive"></router-view>

            <v-snackbar :value="true" :timeout="0" bottom multi-line v-if="needUpdate">
                <div>
                    <div class="body-2">
                        {{ $t("message.update_app") }}
                    </div>
                    <div class="body-1">{{ $t("message.warning_reload") }}</div>
                </div>
                <v-btn text dark class="green--text" @click="updateApp">{{
                    $t("button.update")
                }}</v-btn>
            </v-snackbar>
        </v-content>
        <v-footer class="pa-3">
            <router-link :to="{ name: 'privacy-policy' }">{{
                $t("label.privacy_policy")
            }}</router-link>
            <v-spacer></v-spacer>
            <small>v{{ version }}</small>
        </v-footer>
    </v-app>
</template>

<script>
import { mapGetters, mapActions } from "vuex"
//import firebase from "./firebase"
export default {
    metaInfo: {
        title: "TopSnap",
        titleTemplate: "%s",
        meta: [
            {
                "http-equiv": "Content-Type",
                content: "text/html; charset=utf-8",
            },
            {
                name: "viewport",
                content: "width=device-width, initial-scale=1",
            },
            { name: "description", content: "TopSnap" },
        ],
    },
    apollo: {
        me: {
            query: require("@/graphql/account/me.gql"),
            update({ me }) {
                this.setInfo(me)
                return me
            },
            skip() {
                return !Boolean(this.userLogged)
            },
        },
    },
    name: "App",
    mounted() {
        window.addEventListener("focus", () => {
            if (!this.offline) {
                this.checkForSWUpdate()
            }
        })
        // if (this.pushNotificationToken) {
        //     firebase.handleNotification()
        // }
        window.addEventListener("online", () => {
            this.offline = false
        })
        window.addEventListener("offline", () => {
            this.offline = true
        })
    },
    data() {
        return {
            active: "",
            drawer: false,
            offline: !navigator.onLine,
            version: process.env.VUE_APP_VERSION,
        }
    },
    computed: {
        ...mapGetters({
            loading: "loading",
            pushNotificationToken: "user/pushNotificationToken",
            userLogged: "user/logged",
            name: "user/name",
            locale: "user/locale",
            email: "user/email",
            darkMode: "user/darkMode",
            serverStatus: "serverStatus",
            needUpdate: "needUpdate",
        }),
        routeKey() {
            return this.$route.meta.key || this.$route.fullPath
        },

        items() {
            return [
                {
                    icon: "account_circle",
                    text: this.$t("menu.my_account"),
                    model: false,
                    divider: true,
                    large: true,
                    color: "green",
                    children: [
                        {
                            icon: "settings",
                            text: this.$t("menu.account_settings"),
                            to: { name: "account" },
                        },
                        {
                            icon: "logout",
                            text: this.$t("menu.logout"),
                            action: this.logout,
                            color: "red",
                        },
                    ],
                },
                {
                    text: this.$t("menu.traps"),
                    model: false,
                    divider: true,
                    icon: "inbox",
                    to: {
                        name: "traps",
                    },
                },
                {
                    text: this.$t("menu.categories"),
                    model: false,
                    divider: true,
                    icon: "category",
                    to: {
                        name: "categories",
                    },
                },
                {
                    text: this.$t("menu.plans"),
                    model: false,
                    divider: true,
                    icon: "place",
                    to: {
                        name: "plans",
                    },
                },
                {
                    text: this.$t("menu.stats"),
                    model: false,
                    divider: true,
                    icon: "assessment",
                    to: {
                        name: "stats",
                    },
                },
            ]
        },
    },
    methods: {
        ...mapActions({
            logoutUser: "user/logout",
            setInfo: "user/setInfo",
        }),
        logout() {
            this.me = null
            this.logoutUser()
            this.$router.push({ name: "login" })
        },
        callAction(action) {
            if (action) {
                action()
            }
        },
        updateApp() {
            if (navigator.serviceWorker) {
                navigator.serviceWorker.getRegistration().then(function(reg) {
                    if (reg) {
                        console.log(reg)
                        reg.unregister().then(function() {
                            location.reload(true)
                        })
                    } else {
                        location.reload(true)
                    }
                })
            } else {
                location.reload(true)
            }
        },
        async checkForSWUpdate() {
            if ("serviceWorker" in navigator) {
                const registration = await navigator.serviceWorker.getRegistration()
                if (registration) {
                    registration.update()
                }
            }
        },
    },
}
</script>

<style lang="scss">
.web-site-title a {
    text-decoration: none;
}
.v-slide-group__next,
.v-slide-group__prev {
    flex: 1 1 0px !important;
    min-width: 0 !important;
}
.v-tabs-bar.v-tabs-bar--is-mobile .v-tab {
    margin-left: 0px !important;
}
@media only screen and (max-width: 959px) {
    .no-padding-top {
        /*margin-top: 0px !important;
        padding-top: 0px !important;*/
    }
}
.v-window--container {
    height: auto !important;
}
.vue-notification {
    padding: 15px;
    margin: 5px 5px 5px;
    min-width: 400px;
    font-size: 14px;

    color: #ffffff;
    background: #44a4fc;
    border-left: 5px solid #187fe7;

    &.warn {
        background: #ffb648;
        border-left-color: #f48a06;
    }

    &.error {
        background: #e54d42;
        border-left-color: #b82e24;
    }

    &.success {
        background: #68cd86;
        border-left-color: #42a85f;
    }
}

@media only screen and (max-width: 600px) {
    .container {
        &.no-padding-mobile {
            .layout .flex {
                padding: 8px 10px;
            }
            .layout {
                &:not(:only-child) {
                    margin: auto 0px;
                }
                &:only-child {
                    margin: 0;
                }
            }
            padding: 5px 0px 0px 0px;
        }
        &.no-padding-bottom {
            padding-bottom: 0px;
        }
    }
    .v-tabs {
        &.no-margin-mobile {
            margin: auto 0px;
        }
    }
}
.v-card {
    .v-card--actions {
        padding: 16px;
    }
    border-radius: 10px !important;
}
.v-tabs {
    border-radius: 10px 10px 0px 0px;
}
.v-btn {
    margin: 6px 8px;
}
.v-toolbar__content .v-btn {
    margin: inherit;
}

.v-timeline-item__divider {
    min-width: auto !important;
    margin-right: 15px !important;
}
.v-timeline--dense:not(.v-timeline--reverse):before {
    left: calc(13px - 1px) !important;
}
.v-chip {
    border-color: inherit !important;
    margin: 4px;
    border-radius: 7px !important;
    &.v-size--small {
        margin-right: 6px;

        background-color: rgba(76, 175, 80, 0.3);
    }
}

.v-menu--content {
    max-width: 90%;
}
.v-list-group {
    border-bottom: 1px solid #999;
}
.trap-title {
    font-size: 20px !important;
    font-weight: 500;
    line-height: 1 !important;
    letter-spacing: 0.02em !important;
    height: 24px;
}
.mb-0 {
    .v-messages {
        height: 0;
        min-height: 0;
    }
    .v-text-field--details {
        margin-bottom: 0px !important;
    }
}

.v-timeline--dense .v-timeline-item__body {
    max-width: calc(100%) !important;
}
</style>
